import { __read } from "tslib";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { HeaderCellContent } from '../../header-cell-content';
import { SortIndicators } from '../sort-indicators';
import { Container } from './header.styles';
export var Header = function (_a) {
    var isSorted = _a.isSorted, isSortedDescending = _a.isSortedDescending, textAlignment = _a.textAlignment, columnName = _a.columnName;
    var _b = __read(useState(false), 2), isHovered = _b[0], setHover = _b[1];
    var _c = __read(useState(null), 2), sortMode = _c[0], setSortMode = _c[1];
    var showColumnActions = isSorted || isHovered;
    useEffect(function () {
        if (isSorted) {
            setSortMode(isSortedDescending ? 'descending' : 'ascending');
        }
        else {
            setSortMode(null);
        }
    }, [isSortedDescending]);
    return (React.createElement(Container, { "data-testid": "table-value-header", onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, textAlignment: textAlignment },
        React.createElement(HeaderCellContent, { textAlignment: textAlignment },
            columnName,
            React.createElement(motion.div, { animate: showColumnActions ? { opacity: 1 } : { opacity: 0 }, style: showColumnActions
                    ? { visibility: 'visible' }
                    : { visibility: 'hidden' }, transition: { delay: 0.1, duration: 0.2 } },
                React.createElement(SortIndicators, { sortMode: sortMode })))));
};
